module.exports = __webpack_public_path__ + "img/2.77969c2e.png";